import { Vue, Component, Prop } from 'vue-property-decorator';
import type { CreateElement, VNode } from 'vue';

@Component
export default class IPSDialog extends Vue {
  dialogShow = false;
  confirm = true;
  confirmloading = false;
  readonly = false;
  confirmText = '确认';
  cancelText = '关闭';
  title = '标题';
  footer = true;
  width = '1000px';
  top = '15vh';
  scroll = true;

  static open(c?): Promise<any> {
    return new Promise(() => {});
  }

  close() {
    this.dialogShow = false;
    setTimeout(() => {
      this.$emit('hidden');
    });
  }

  onCancel() {
    this.close();
    this.$emit('cancel');
  }

  getResults() {
    return {};
  }

  beforeConfirm(resp = {}, cb) {
    console.info('beforeConfirm');
    cb(resp);
  }

  onConfirm() {
    const re = this.getResults();
    this.confirmloading = true;
    this.beforeConfirm(re || {}, (close = true, params?) => {
      if (close) {
        this.close();
      }
      this.confirmloading = false;
      this.$emit('result', re, params);
    });
  }

  beforeClose() {
    this.close();
    this.$emit('cancel');
  }

  renderContent(h) {
    return <h1>请覆盖</h1>;
  }

  renderFooter(h) {
    return (
      <span slot="footer" class="dialog-footer font-size-14">
        <el-button onClick={this.onCancel.bind(this)}>{this.cancelText}</el-button>
        {this.confirm && (
          <el-button type="primary" onClick={this.onConfirm} loading={this.confirmloading} disabled={this.readonly}>
            {this.confirmText}
          </el-button>
        )}
      </span>
    );
  }

  render(h: CreateElement): VNode {
    return this.renderDialog(h);
  }

  renderDialog(h) {
    const maxHeight = window.innerHeight * 0.8;
    // const topOffset = (window.innerHeight * 0.4) / 2;
    const dialogConf = {
      attrs: this.$attrs,
      props: {
        width: this.width,
        closeOnClickModal: false,
        appendToBody: true,
        beforeClose: this.beforeClose,
        visible: this.dialogShow,
        top: this.top,
        ...this.$props,
      },
    };
    return (
      <el-dialog v-dialogDrag {...dialogConf}>
        <template slot="title">
          {this.$attrs.title || this.$slots.title || this.title}
          &nbsp;
        </template>
        <div ref="dialogContainer" class={['dialogContainer height-100', this.scroll && 'scroll']} style={{ maxHeight: `${maxHeight}px` }}>
          {this.$slots.default || this.renderContent(h)}
        </div>
        {this.footer && <span slot="footer">{this.$slots.footer}</span>}
        {!this.$slots.footer && this.footer && this.renderFooter(h)}
      </el-dialog>
    );
  }
}
